import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['link']

  linkTargetConnected(link) {
    link.addEventListener('click', this.handleClick)
  }

  linkTargetDisconnected(link) {
    link.removeEventListener('click', this.handleClick)
  }

  handleClick = (event) => {
    this.linkTargets.forEach(link => {
      link.classList.remove('active')
    })
    event.currentTarget.classList.add('active')
  }
}
